import React from 'react';
import PropTypes from 'prop-types';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import commonStyles from '../../styles';

const headCells = [
  { id: 'number', label: 'No' },
  { id: 'lastReceivedAt', label: '最終受信日時' },
  { id: 'customerId', label: '顧客ID' },
  { id: 'customer', label: '顧客' },
  { id: 'lileLink', label: 'LINEリンク' },
  { id: 'user', label: '担当' },
  { id: 'userLevel', label: 'ランク' },
  { id: 'detachedHouseBudgetMax', label: '戸建上限' },
  { id: 'landBudgetMax', label: '土地上限' },
  { id: 'wishArea', label: '希望地域' },
  { id: 'annualIncome', label: <span>年収<br />（万円）</span> },
];

export default function LineReceptionTableHeader(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
  } = props;

  const baseClasses = commonStyles();

  LineReceptionTableHeader.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  /**
   * ヘッダーの各項目をクリックした時に実行されるハンドラーを生成する。
   * 「カリー化」という手法を使って、クリックイベントと列IDをセットにして親に渡します。
   */
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead className={classes.thead}>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            className={`${baseClasses.title4} ${classes.tableCellTh}`}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              className={classes.tableSortLabel}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
